import { NgModule } from '@angular/core';
import {RouterModule, Routes, UrlSegment} from '@angular/router';
import {HomeComponent} from "./pages/home/home.component";
import {AttendRoomComponent} from "./pages/player/attend-room/attend-room.component";
import {AuthComponent} from "./pages/auth/auth.component";
import {ForgotPasswordComponent} from "./pages/forgot-password/forgot-password.component";


import {authGuard} from "./guards/auth.guard";
import {profileRequirementsGuard} from "./guards/profile-requirements.guard";
import {NotFoundComponent} from "./pages/not-found/not-found.component";
import {UnauthorizedComponent} from "./pages/unauthorized/unauthorized.component";
import {JoinRoomComponent} from "./pages/player/join-room/join-room.component";
import {PrivacyComponent} from "./pages/policy/privacy/privacy.component";
import {TermsComponent} from "./pages/policy/terms/terms.component";
import {AuthCallbackComponent} from "./pages/auth-callback/auth-callback.component";
import {AcceptInviteComponent} from "./pages/player/accept-invite/accept-invite.component";
import {EditProfileComponent} from "./pages/player/edit-profile/edit-profile.component";
import {ViewGroupmatesComponent} from "./pages/player/view-groupmates/view-groupmates.component";
import {ViewRoomsComponent} from "./pages/player/view-rooms/view-rooms.component";
import {DocsComponent} from "./pages/docs/docs.component";
import {DebugComponent} from "./pages/debug/debug.component";
import { ReviewRoomComponent } from './pages/player/review-room/review-room.component';

const routes: Routes = [
  {
    path: '', component: HomeComponent
  },
  {
    path: 'auth', component: AuthComponent
  },
  {
    path: 'signup', redirectTo: '/auth?mode=signup', pathMatch: 'full'
  },
  {
    path: 'signin', redirectTo: '/auth?mode=signin', pathMatch: 'full'
  },
  {
    path: 'signout', redirectTo: '/', pathMatch: 'full'
  },
  {
    path: 'auth/callback', component: AuthCallbackComponent
  },
  {
    path: 'recover-password', component: ForgotPasswordComponent
  },
  {
    path: 'edit-profile', component: EditProfileComponent
  },
  {
    path: 'take-selfie',
    loadComponent: () =>
      import('./pages/player/take-selfie/take-selfie.component')
        .then(m => m.TakeSelfieComponent),
    canActivate: [authGuard]
  },
  {
    path: 'selfie-requests/:requestId',
    loadComponent: () =>
      import('./pages/player/take-selfie/take-selfie.component')
        .then(m => m.TakeSelfieComponent),
    canActivate: [authGuard]
  },
  {
    path: 'invite/:inviteCode', component: AcceptInviteComponent
  },
  {
    path: 'join/:roomId', component: JoinRoomComponent, canActivate: [authGuard]
  },
  {
    path: 'review-room/:roomId', component: ReviewRoomComponent, canActivate: [authGuard]
  },
  {
    path: 'rooms/:roomId', component: AttendRoomComponent, canActivate: [authGuard, profileRequirementsGuard]
  },
  {
    path: 'rooms', component: ViewRoomsComponent, canActivate: [authGuard]
  },
  {
    path: 'groupmates', component: ViewGroupmatesComponent, canActivate: [authGuard]
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.routes')
        .then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'docs/:doc', component: DocsComponent
  },
  { path: 'debug', component: DebugComponent},
  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
